module.exports = __webpack_public_path__ + "img/wz-7-3-4.5a73e592.jpg";